<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-card-text class="app-card-content pl-0 pr-0">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex lg12 sm12 xs12 class="pt-0">

              <div class="header-box">
                <div class="header-content">
                  <div class="header-left">
                    <div class="header-user">
                      <div class="user-name">{{ user.name }}</div>
                      <div class="user-sigla">{{ user.sigla }}</div>
                    </div>
                  </div>

                  <div class="header-right">
                    <v-btn
                      class="logout-btn"
                      depressed
                      small
                      @click="logout()"
                      aria-label="Sair"
                    >
                      Sair
                      <v-icon right small>arrow_forward</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>

              <FiltroLotes />

              <div class="mb-3 d-flex flex-wrap">
                <GeneratePDF
                  :itemsPerPage="tableLotes.paginate.size"
                  :head="tableLotes.header.filter(v => v.value !== 'graficaNomeFantasia')"
                  :title="'Lotes'"
                  :report-data="searchJSON"
                  :disable="tableLotes?.total === 0"
                  class="mb-2 mr-2"
                />
                <GenerateExcel
                  :itemsPerPage="tableLotes.paginate.size"
                  :head="tableLotes.header.filter(v => v.value !== 'graficaNomeFantasia')"
                  :title="'Lotes'"
                  :report-data="searchJSON"
                  :disable="tableLotes?.total === 0"
                  class="mb-2"
                />
              </div>

              <!-- Tabela desktop -->
              <v-data-table
                class="d-none d-sm-block"
                :headers="tableLotes.header.filter(v => v.value !== 'graficaNomeFantasia')"
                :items="tableLotes.content"
                :item-key="'id'"
                :loading="tableLotes.isLoading"
                :items-per-page="tableLotes.paginate.size"
                :options.sync="pagination"
                :server-items-length="tableLotes.total"
                :footer-props="{ 
                  showFirstLastPage: true, 
                  showCurrentPage: true,
                  itemsPerPageOptions: [5, 10, 50, tableLotes.total].sort((a,b) => a-b).filter(v => v!==0)
                }"
              >
                <template #item.id="{ item }"><span>{{ item.id }}</span></template>
                <template #item.entidadeSigla="{ item }"><span>{{ item.entidadeSigla }}</span></template>
                <template #item.situacao="{ item }"><span>{{ item.situacao }}</span></template>
                <template #item.createdDate="{ item }"><span>{{ item.createdDate }}</span></template>

                <template #item.acoes="{ item }">
                  <v-btn icon small :ripple="false" @click.stop.prevent="confirmacaoRecebinetoLote(item)">
                    <v-icon color="primary" title="Download do lote">arrow_downward</v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    small
                    :ripple="false"
                    v-if="item.enviarSindonibus"
                    @click.stop.prevent="confirmacaoSidionibus(item)"
                  >
                    <v-icon color="primary" title="Enviar Lote para Sindiônibus">call_made</v-icon>
                  </v-btn>
                </template>
              </v-data-table>

              <!-- Cards mobile -->
              <div class="d-block d-sm-none">
                <v-card
                  v-for="item in pagedItems"
                  :key="item.id"
                  outlined
                  class="mb-2 pa-2 cursor-pointer"
                >
                  <v-row>
                    <v-col cols="12">
                      <div class="caption">
                        Lote: <span class="font-weight-bold" style="color: #1976d2">{{ item.id }}</span>
                      </div>
                      <div class="caption">Entidade: {{ item.entidadeSigla || item.graficaNomeFantasia }}</div>
                      <div class="caption">Status: {{ item.situacao }}</div>
                      <div class="caption">Data: {{ item.createdDate }}</div>
                    </v-col>

                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn icon small :ripple="false" @click.stop.prevent="confirmacaoRecebinetoLote(item)">
                        <v-icon color="primary" title="Download do lote">arrow_downward</v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        small
                        :ripple="false"
                        v-if="item.enviarSindonibus"
                        @click.stop.prevent="confirmacaoSidionibus(item)"
                      >
                        <v-icon color="primary" title="Enviar Lote para Sindiônibus">call_made</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Paginação mobile -->
                <v-row class="justify-center mt-2 mb-2">
                  <v-pagination
                    v-model="mobilePage"
                    :length="mobileTotalPages"
                    @input="onMobilePageChange"
                  >
                    <template v-slot:item="{ page, isActive, disabled }">
                      <v-btn
                        v-if="page === 1 || page === mobileTotalPages || page === mobilePage"
                        :color="isActive ? 'primary' : ''"
                        :disabled="disabled"
                        small
                        @click="onMobilePageChange(page)"
                      >
                        {{ page }}
                      </v-btn>
                      <v-btn
                        v-else-if="page === 'prev'"
                        icon
                        @click="mobilePage > 1 && onMobilePageChange(mobilePage - 1)"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-btn
                        v-else-if="page === 'next'"
                        icon
                        @click="mobilePage < mobileTotalPages && onMobilePageChange(mobilePage + 1)"
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </template>
                  </v-pagination>
                </v-row>

                <div class="d-flex justify-center align-center mb-1">
                  <span class="caption">
                    Página {{ mobilePage }} de {{ mobileTotalPages }}
                  </span>
                </div>

              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <OpenDialogConfirmar 
        :openDialog="dialogRecebimentoLote"
        message="Ao baixar a primeira vez o lote, você o estará recebendo oficialmente. O mesmo mudará de status e o Aluno será informado por e-mail."
        :onClose="()=>{dialogRecebimentoLote=false}"
        :onClick="()=>{downloadLote(dadosRecebimento)}"
      />
      <OpenDialogConfirmar 
        :openDialog="dialogSindionibus"
        message="Somente confirme o envio do Lote para o Sindiônibus caso todas as carteiras já tenham sido fisicamente entregues ao Sindiônibus. O lote mudará de status e o Aluno será informado por e-mail."
        :onClose="()=>{dialogSindionibus=false}"
        :onClick="enviarLote"
      />
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FiltroLotes from "./FiltroLotes.vue";
import GenerateExcel from "@/components/GenerateExcel.vue";
import GeneratePDF from "@/components/GeneratePDF.vue";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import GlobalStore from "@/store/modules/global";
import { router } from "@/router";
import OpenDialogConfirmar from "@/components/OpenDialogConfirmar.vue";
import GraficaService from "@/services/sie-pedidos/grafica.service";
import AuthService from "@/services/sie-pedidos/auth.service";

const actions = mapActions('siePedidos', [
  'setTableLotesContent', 
  'setTableLotesIsLoading', 
  'setTableLotesTotals', 
  'clearTableLotes', 
  'setTableLotesPagination'
]);
const state = mapState('siePedidos', ['tableLotes']);

export default {
  components: { OpenDialogConfirmar, FiltroLotes, GenerateExcel, GeneratePDF },
  data: () => ({
    pagination: null,
    user: { name: null, sigla: null },
    dadosSindionibus: null,
    dadosRecebimento: null,
    dialogSindionibus: false,
    dialogRecebimentoLote: false,
    mobilePage: 1,
    mobilePageSize: 5
  }),
  computed: {
    ...state,
    mobileTotalPages() {
      return Math.max(1, Math.ceil((this.tableLotes.total || 0) / this.mobilePageSize));
    },
    pagedItems() {
      return this.tableLotes.content || [];
    }
  },
  watch: {
    pagination: { handler() { this.changePagination(); }, deep: true }
  },
  mounted() {
    this.getDadosUserLogado();
    if (!this.pagination) this.pagination = { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] };
    this.changePagination();
  },
  destroyed() { this.clearTableLotes(); },
  methods: {
    ...actions,

    getDadosUserLogado() {
      AuthService.dadosUserGraficaLogado(false).then(result => {
        if(result){
          const user = JSON.parse(localStorage.getItem("dadosUserLogado")) || {};
          this.user = user;
        } else {
          router.push('/carteira-macrorregiao/grafica/');
        }
      });
    },

    changePagination() {
      const { id } = this.$route.params;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination || { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] };
      let input = { ...this.tableLotes.paginate };
      if (Object.prototype.hasOwnProperty.call(this.$route.query, "situacao")) {
        const { situacao } = this.$route.query;
        input = { ...this.tableLotes.paginate, situacao };
      }

      const sortByKey = sortBy?.length ? sortBy[0] : 'id';
      const sortOrder = sortDesc?.[0] ? 'DESC' : 'ASC';

      const paginate = {
        ...this.tableLotes.paginate,
        ...input,
        graficaId: id,
        page: page - 1,
        size: itemsPerPage === 'Total' ? this.tableLotes.total : itemsPerPage,
        sortBy: sortByKey,
        sortOrder
      };
      this.setTableLotesPagination(paginate);
      this.search();
    },

    search() {
      this.setTableLotesIsLoading(true);
      GraficaService.getListaLotes(this.tableLotes.paginate).subscribe(
        ({ result }) => {
          this.setTableLotesContent(result?.data);
          this.setTableLotesTotals(result.totalElements);
          this.setTableLotesIsLoading(false);
        },
        () => { this.setTableLotesIsLoading(false); }
      );
    },

    confirmacaoSidionibus(item) {
      this.dadosSindionibus = item;
      this.dialogSindionibus = true;
    },

    confirmacaoRecebinetoLote(item) {
      if(item.situacao === "Lote Disponível para Gráfica") {
        this.dadosRecebimento = item;
        this.dialogRecebimentoLote = true;
      } else {
        this.downloadLote(item);
      }
    },

    downloadLote(item) {
      GraficaService.downloadLote(item.id).subscribe({
        next: (result) => {
          const filename = `LOTE-${item.id}.zip`;
          const blob = new Blob([result], { type: 'application/octet-stream' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
          GlobalStore.setSnackBar('setSnackBar', { show: true, message: 'Arquivo baixado com sucesso', type: 'success' });
          this.search();
          this.dadosRecebimento = null;
          this.dialogRecebimentoLote = false;
        }
      });
    },

    logout() {
      AuthService.logout();
      AuthService.globalStore("success", "Saiu com sucesso!");
    },

    searchJSON() {
      return new Promise((resolve, reject) => {
        GraficaService.getListaLotes({ ...this.tableLotes.paginate, size: this.tableLotes.total, page: 0 }).subscribe(
          ({ result }) => {
            const formatted = result.data.map(i => ({
              id: i.id,
              entidadeSigla: i.entidadeSigla,
              situacao: i.situacao,
              createdDate: FunctionsCommuns.formatBRDateHora(i.createdDate)
            }));
            resolve(formatted);
          },
          (error) => reject(error)
        );
      });
    },

    enviarLote() {
      const item = this.dadosSindionibus;
      GraficaService.enviarLoteSindionibus(item.id).subscribe({
        next: response => {
          AuthService.globalStore("success", response.message);
          this.search();
        },
        error: error => {
          const msg = error?.response?.data?.message || "Erro ao enviar";
          AuthService.globalStore("error", msg);
        }
      });
      this.dialogSindionibus = false;
    },

    onMobilePageChange(page) {
      if (page < 1) page = 1;
      if (page > this.mobileTotalPages) page = this.mobileTotalPages;
      this.mobilePage = page;

      const { id } = this.$route.params;
      const paginate = {
        ...this.tableLotes.paginate,
        graficaId: id,
        page: page - 1,
        size: this.mobilePageSize
      };

      this.setTableLotesPagination(paginate);
      this.setTableLotesIsLoading(true);
      GraficaService.getListaLotes(paginate).subscribe(
        ({ result }) => {
          this.setTableLotesContent(result.data);
          this.setTableLotesTotals(result.totalElements);
          this.setTableLotesIsLoading(false);
        },
        () => { this.setTableLotesIsLoading(false); }
      );
    },
  },
};
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }

.v-card.cursor-pointer {
  transition: box-shadow 0.2s ease-in-out, transform 0.06s ease;
}
.v-card.cursor-pointer:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  transform: translateY(-1px);
}

.header-box {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
  padding: 10px 16px;
  box-sizing: border-box;
  margin-bottom: 12px;
  position: relative;
  z-index: 90;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.header-left { display: flex; align-items: center; }
.header-user { display: flex; flex-direction: column; }
.user-name { font-weight: 600; font-size: 1rem; }
.user-sigla { font-size: 0.85rem; color: rgba(0,0,0,0.6); }

.logout-btn {
  min-width: 88px;
  height: 36px;
  padding-left: 12px;
  padding-right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 420px) {
  .logout-btn {
    min-width: 64px;
    height: 32px;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 0.85rem;
  }
  .logout-btn .v-icon { font-size: 18px; }
}

.header-box { pointer-events: auto; }
.app-card-content { position: relative; z-index: 1; }
</style>
